import React from 'react';
import { Typography, Menu, MenuItem, Button } from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList';
import '../styles/components/CategoryTitle.scss';

const CategoryTitle = ({ header }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <div className='category-title'>
            <Typography variant='h4'>{header}</Typography>
            <div className='category-menu'>
                {/* <Button id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    endIcon={<FilterListIcon />}>
                    Sort by
                </Button> */}
                <div>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        className='filter-options'
                    >
                        <MenuItem>Recently Viewed</MenuItem>
                        <MenuItem>Mostly ordered</MenuItem>
                    </Menu>
                </div>
            </div>
        </div>
    )
}

export default CategoryTitle